import { render } from "./Kbshow.vue?vue&type=template&id=841825ce"
import script from "./Kbshow.vue?vue&type=script&lang=js"
export * from "./Kbshow.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__